import { queryOptions } from '@tanstack/react-query';

import { parseSchema } from '@repo/utils/parse-schema';

import { http } from '~/services/http.ts';

import { invoiceSchema, invoiceSummarySchema } from './types.ts';

const apiBase = `${import.meta.env.VITE_API_BASE}/invoice`;

export async function getInvoices(projectId: string) {
  return parseSchema(invoiceSummarySchema.array(), await http(`${apiBase}/projects/${projectId}/invoices`));
}

export function queryInvoices(projectId: string) {
  return queryOptions({
    queryFn: () => getInvoices(projectId),
    queryKey: ['invoices', projectId],
  });
}

export async function getInvoiceById(projectId: string, invoiceId: string) {
  return parseSchema(invoiceSchema, await http(`${apiBase}/projects/${projectId}/invoices/${invoiceId}`));
}

export function queryInvoiceById(projectId: string, invoiceId: string) {
  return queryOptions({
    queryFn: () => getInvoiceById(projectId, invoiceId),
    queryKey: ['invoice', projectId, invoiceId],
  });
}
